export default __webpack_public_path__ + "static/broadcast5-be17f6daacf48311cc0664119aa9d62f.png";